module.exports = __webpack_public_path__ + "files/7f5dc2bb4249c401e0e961cbf822e2f4.png";